import { render, staticRenderFns } from "./Insurers.vue?vue&type=template&id=78093f8e&"
import script from "./Insurers.vue?vue&type=script&lang=ts&"
export * from "./Insurers.vue?vue&type=script&lang=ts&"
import style0 from "./Insurers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports